import { ContentUnavailableView } from './content-unavailable.view';
import { LoadIndicatorCenteredView } from './load-indicator/load-indicator-centered.view';

//A load that has not finished yet and a load that failed are not the same state,
//and every study surface needs to tell them apart the same way. Keeping the
//choice here stops the four call sites from drifting. DEV-397.
export const LoadStateView = ({ loadFailed, failedMessage }: { loadFailed?: boolean; failedMessage?: string }) => {
    if (loadFailed) {
        return <ContentUnavailableView message={failedMessage} />;
    }

    return <LoadIndicatorCenteredView />;
};
